import '../../TagPicker.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a;
import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import "../../Utilities.js";
import "../../Styling.js";
import { TagItem } from "@fluentui/react/lib/Pickers";
import { OverflowSet } from "@fluentui/react/lib/OverflowSet";
import { TagPickerErrors } from "./TagPicker.constants.js";
import "../Label/index.js";
import "../ValidationError/index.js";
import { TagPickerWrapper } from "./TagPickerWrapper.js";
import "../ReadOnly/index.js";
import { getTheme, mergeStyles } from "@fluentui/style-utilities";
import { getId, css } from "@fluentui/utilities";
import { Label } from "../Label/Label.js";
import { InputValue } from "../ReadOnly/InputValue.js";
import { ValidationError } from "../ValidationError/ValidationError.js";
const TagPicker$1 = "";
const rootClassName = "ane-TagPicker-container";
const defaultClassName = "ane-TagPicker";
class TagPicker extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "_componentRef", null);
    __publicField(this, "state", {
      selectedItems: ((_a = this.props.tagPickerProps) == null ? void 0 : _a.selectedItems) || [],
      errorMessage: this.props.errorMessage || ""
    });
    __publicField(this, "_clearTextInput", false);
    /**
     * TODO - Validation logic should be included in this base component
     * currently we handle all validation in new experiences within the Formik wrapper
     * the TagPickerField implementation does not read from the errorMessage in the onChange callback
     * @param tag
     */
    __publicField(this, "_isTagSelected", (tag) => {
      const { selectedItems } = this.state;
      return this._containsTag(tag, selectedItems);
    });
    __publicField(this, "_isTagValid", (tag) => {
      const { tagPickerProps } = this.props;
      const { items } = tagPickerProps;
      return this._containsTag(tag, items);
    });
    __publicField(this, "_isTagAllowed", (tag) => {
      const { tagPickerProps } = this.props;
      const { allowNewItems } = tagPickerProps;
      const isTagValid = !!this._isTagValid(tag);
      return !!allowNewItems ? true : isTagValid;
    });
    __publicField(this, "_onInputBlur", (event) => {
      var _a2;
      const { selectedItems } = this.state;
      let tags = selectedItems;
      if (!!((_a2 = event == null ? void 0 : event.target) == null ? void 0 : _a2.value)) {
        const tag = { key: event.target.value, name: event.target.value };
        const isTagAllowed = this._isTagAllowed(tag);
        if (!!isTagAllowed) {
          tags = [...selectedItems, tag];
          this._componentRef.state.inputValue = "";
        }
      }
      this._onChange(tags);
    });
    __publicField(this, "_onRenderLabel", (inputId, props) => {
      const { label, labelProps = null, required = false, disabled = false } = props;
      return /* @__PURE__ */ jsx(
        Label,
        __spreadProps(__spreadValues({}, labelProps), {
          required,
          disabled,
          htmlFor: `${inputId}-component`,
          id: `${inputId}-label`,
          children: label
        })
      );
    });
    /* Default logic provides alphabetical filtering with removal of potential duplicates */
    __publicField(this, "_onResolveSuggestions", (filter, selectedItems) => {
      const { tagPickerProps } = this.props;
      const { allowNewItems = false, items = [] } = tagPickerProps;
      const removeDuplicates = this._filterSelectedItems(items, selectedItems);
      const existingMatches = !!filter ? removeDuplicates.filter((tag) => tag.name && tag.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1) : items;
      if (allowNewItems)
        return existingMatches.concat({ key: filter, name: filter, isNewItem: true });
      else
        return existingMatches;
    });
    /* Shows all suggestions when User clicks on an empty TagPicker */
    __publicField(this, "_onEmptyInputFocus", (selectedItems) => {
      const { tagPickerProps } = this.props;
      const { items = [], onEmptyInputFocus = null } = tagPickerProps;
      return onEmptyInputFocus ? onEmptyInputFocus(selectedItems) : this._filterSelectedItems(items, selectedItems);
    });
    __publicField(this, "_onInputPaste", (event) => {
      var _a2;
      if (!event)
        return;
      const { tagPickerProps } = this.props;
      const { allowNewItems, items = [] } = tagPickerProps || {};
      let errorMessage = "";
      let values = "";
      let valuesNotUnique = [];
      let valuesNotValid = [];
      const selectedItems = this.state.selectedItems || [];
      try {
        values = event.clipboardData.getData("text/plain");
      } catch (e) {
        errorMessage += TagPickerErrors.paste;
      }
      if (!!values) {
        this._clearTextInput = !tagPickerProps.resolveDelay ? true : false;
        const selectedItemsDictionary = {};
        (_a2 = this.state.selectedItems) == null ? void 0 : _a2.forEach((item) => {
          const { name } = item;
          selectedItemsDictionary[name] = name;
        });
        values.split(";").forEach((str) => {
          const value = str.trim();
          const isUnique = !selectedItemsDictionary[value];
          const item = (items == null ? void 0 : items.filter((item2) => item2.name === value).pop()) || null;
          const validOption = !!allowNewItems || !!item;
          if (!tagPickerProps.resolveDelay) {
            if (!isUnique) {
              valuesNotUnique.push(`${value}`);
            }
            if (!validOption) {
              valuesNotValid.push(`${value}`);
            }
            if (!isUnique || !validOption) {
              return;
            }
            if (value !== "") {
              selectedItemsDictionary[value] = value;
              selectedItems.push(!!item ? item : { key: value, name: value });
            }
          }
        });
        if (!!valuesNotUnique.length) {
          errorMessage += `${TagPickerErrors.duplicates} ${valuesNotUnique.join(";")}  `;
        }
        if (!!valuesNotValid.length) {
          errorMessage += `${TagPickerErrors.invalid} ${valuesNotValid.join(";")}  `;
        }
      }
      this._onChange(selectedItems, errorMessage);
    });
    __publicField(this, "_onInputChange", (input) => {
      const value = !!this._clearTextInput ? "" : input;
      this._clearTextInput = false;
      return value;
    });
    __publicField(this, "_onChange", (items, errorMessage = this.state.errorMessage) => {
      const { tagPickerProps } = this.props;
      const { onChange } = tagPickerProps;
      !!onChange && onChange(items, errorMessage);
      this.setState({
        selectedItems: items,
        errorMessage
      });
    });
  }
  componentDidUpdate(prevProps) {
    var _a2;
    const { tagPickerProps, errorMessage } = this.props;
    const { selectedItems } = tagPickerProps;
    if (((_a2 = prevProps == null ? void 0 : prevProps.tagPickerProps) == null ? void 0 : _a2.selectedItems) !== selectedItems) {
      this.setState({ selectedItems });
    }
    if ((prevProps == null ? void 0 : prevProps.errorMessage) !== errorMessage) {
      this.setState({ errorMessage });
    }
  }
  render() {
    const theme = getTheme();
    const _a2 = this.props, {
      className,
      disabled,
      id = getId("TagPicker"),
      label,
      labelProps,
      showSuggestions = true,
      tagPickerProps,
      placeholder,
      required,
      errorMessage: defaultErrorMessage
    } = _a2, rest = __objRest(_a2, [
      "className",
      "disabled",
      "id",
      "label",
      "labelProps",
      "showSuggestions",
      "tagPickerProps",
      "placeholder",
      "required",
      "errorMessage"
    ]);
    const _b = tagPickerProps, {
      ariaLabel,
      className: inputClassName,
      items,
      onEmptyInputFocus = this._onEmptyInputFocus,
      onResolveSuggestions = this._onResolveSuggestions,
      isReadOnly
    } = _b, restTagPickerProps = __objRest(_b, [
      "ariaLabel",
      "className",
      "items",
      "onEmptyInputFocus",
      "onResolveSuggestions",
      "isReadOnly"
    ]);
    const { selectedItems, errorMessage } = this.state;
    const defaultInputProps = {
      "aria-label": ariaLabel,
      id: `${id}-component`,
      placeholder,
      "aria-required": required,
      onPaste: this._onInputPaste,
      onBlur: this._onInputBlur
    };
    const ariaLabelledBy = !!label ? { "aria-labelledby": `${id}-label` } : {};
    let count = 0;
    return isReadOnly ? /* @__PURE__ */ jsxs("div", { id, children: [
      /* @__PURE__ */ jsx(Label, { htmlFor: `${id}-component`, id: `${id}-label`, children: label }),
      !selectedItems.length ? /* @__PURE__ */ jsx(
        InputValue,
        {
          id,
          value: "",
          className: mergeStyles({
            minHeight: "26px"
          })
        }
      ) : /* @__PURE__ */ jsx(
        OverflowSet,
        {
          id: `${id}-component`,
          role: "list",
          items: selectedItems,
          styles: {
            root: {
              flexWrap: "wrap"
            }
          },
          onRenderItem: (props) => {
            count++;
            return /* @__PURE__ */ jsx(
              TagItem,
              {
                index: count,
                item: props,
                styles: {
                  root: {
                    selectors: {
                      ":hover": [{ background: theme.palette.neutralLighter }]
                    },
                    userSelect: "text"
                  },
                  close: {
                    display: "none"
                  }
                },
                children: props.name
              }
            );
          },
          onRenderOverflowButton: () => null
        }
      )
    ] }) : /* @__PURE__ */ jsxs(
      "div",
      __spreadProps(__spreadValues({}, rest), {
        className: css(rootClassName, className, disabled && "is-disabled", errorMessage && "error-message"),
        id,
        children: [
          !!label && this._onRenderLabel(id, this.props),
          /* @__PURE__ */ jsx(
            TagPickerWrapper,
            __spreadProps(__spreadValues({}, restTagPickerProps), {
              className: mergeStyles(
                /**
                 * a11y fix
                 * override the global tag close focus outline to be the correct color contrast
                 */
                {
                  ":global(.ms-Fabric--isFocusVisible .ms-TagItem-close:focus:after)": {
                    content: "",
                    outline: `1px solid ${theme.palette.white} !important`,
                    TagItem: `${theme.palette.blueLight}`
                  }
                },
                defaultClassName,
                inputClassName
              ),
              disabled,
              inputProps: __spreadProps(__spreadValues(__spreadValues({}, ariaLabelledBy), defaultInputProps), {
                ref: (ref) => this._componentRef = ref
              }),
              selectedItems,
              onResolveSuggestions,
              onEmptyInputFocus,
              pickerCalloutProps: { hidden: !showSuggestions },
              onChange: this._onChange,
              onInputChange: this._onInputChange
            })
          ),
          /* @__PURE__ */ jsx(ValidationError, { text: errorMessage })
        ]
      })
    );
  }
  _filterSelectedItems(options, selectedItems) {
    if (!options || !options.length || options.length === 0) {
      return [];
    }
    return options.filter((tag) => !this._containsTag(tag, selectedItems));
  }
  _containsTag(tag, tagList) {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.filter((otherTag) => otherTag.key && tag.key && otherTag.key === tag.key).length > 0;
  }
}
__publicField(TagPicker, "defaultProps", {
  tagPickerProps: {
    ariaLabel: "",
    removeButtonAriaLabel: ""
  },
  errorMessage: ""
});
export {
  TagPicker,
  TagPicker as default
};
//# sourceMappingURL=TagPicker.js.map
